import { Typography } from "@material-ui/core"
import { useEffect, useState } from "react"
import { Card, Button } from "react-bootstrap"
import { db } from '../firebase'


export default function NewUsers() {
    const [pendingPlayers, setpendingPlayers] = useState([])

    const pendingDBRef = db.collection("pendings")
    const appuserDBRef = db.collection("appusers")

    async function handleDelete(ply) {
        console.log('Confirm delete', ply)
        let playerData
        await db.collection('pendings').doc(ply.uid)
            .get()
            .then((doc) => {
                playerData = doc.data()
            })
            .catch((e) => {
                console.log(e)
            })

        await db.collection('appusers_disabled').doc(ply.uid)
            .set(playerData)
            .then(() => {
                console.log('user added to disabled')
            })
            .catch((e) => {
                console.log(e)
            })

        db.collection('pendings').doc(ply.uid)
            .delete()
            .then(() => {
                getPendings()
            })
            .catch((e) => {
                console.log(e)
            })

        db.collection('appusers').doc(ply.uid)
            .delete()
            .then(() => {
                console.log('removed from appusers')
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function handleApprove(ply) {
        const uid = ply.uid
        console.log(ply)
        appuserDBRef.doc(uid).set(ply)
            .then((doc) => {
                console.log("added to appusers")
            })
            .catch((e) => {
                console.log(e)
            })

        pendingDBRef.doc(uid).delete()
            .then(() => {
                console.log("request deleted")
                getPendings()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function getPendings() {
        pendingDBRef.get()
            .then((querySnapShot) => {
                let resPlyList = []
                querySnapShot.forEach((doc) => {
                    let documentId = doc.id
                    let ply = doc.data()
                    if (!ply.uid) ply.uid = documentId
                    resPlyList.push(ply)
                    console.log(ply)
                })
                console.log(resPlyList)
                setpendingPlayers(resPlyList)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    useEffect(() => {
        getPendings()
    }, [])


    const displayPendingPlayers = pendingPlayers.map((ply, ind) => {
        return (
            <div>
                <Card className="scoreboard">
                    <Card.Title>{ply.displayName}</Card.Title>
                    <Card.Body>
                        <Typography>
                            {ply.universityID}
                        </Typography>
                        <Button onClick={() => handleApprove(ply)}>Approve</Button>
                        <Button onClick={() => handleDelete(ply)}>Delete Request</Button>
                    </Card.Body>
                </Card>
            </div>
        )
    })

    return (
        <div>
            <h3 className="light-text">New Users will be on pending. Once approved they will have a player profile.</h3>
            <ul>
                {displayPendingPlayers}
            </ul>
        </div>
    )
}